import { Component } from 'react'

import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import moment from 'moment'
import { i18n, withTranslation, Link } from '../i18n'
import Layout from '../components/Layout'
import { BroadcastContainer } from '../styles/broadcastStyles'
import { fetchBroadcasts } from '../api/broadcasts'
import Footer from '../components/Footer'

import {
  Container,
  Partner,
  Logo,
  Section,
  Line
} from '../styles/partnersStyles'

import { fetchPartners } from '../api/partners'

const EXTERNAL_PLACE_BROADCAST_ID = 207

const PartnersGrid = ({ partners }) => (
  <div className="grid">
    {partners.map(partner => (
      <Partner key={partner.id} className={partner.type} href={partner.site}>
        <a
          href={partner.site}
          target="_blank"
          rel="noopener noreferrer"
          title={partner.name}
        >
          <Logo className="logo" logo={partner.logo} />
        </a>
      </Partner>
    ))}
  </div>
)

PartnersGrid.propTypes = {
  partners: PropTypes.arrayOf(Object).isRequired
}

const PartnersSection = ({ title }) => (
  <Section>
    <Line />
    <div className="name">{title}</div>
    <Line />
  </Section>
)

PartnersSection.propTypes = {
  title: PropTypes.string.isRequired
}

class Broadcast extends Component {
  static async getInitialProps({ req }) {
    const currentLanguage = req ? req.language : i18n.language
    const broadcasts = await fetchBroadcasts(currentLanguage)
    const partners = await fetchPartners(0, {}, 1000, currentLanguage)
    return {
      namespacesRequired: ['common', 'partners'],
      broadcasts: broadcasts?.results || [],
      partners: partners?.results || []
    }
  }

  static propTypes = {
    t: PropTypes.func.isRequired,
    broadcasts: PropTypes.arrayOf(Object).isRequired,
    partners: PropTypes.arrayOf(Object).isRequired
  };

  state = {
    currentBroadcast: 0
  };

  render() {
    const { t, broadcasts, partners } = this.props
    const { currentBroadcast } = this.state

    const currentPlace = broadcasts[currentBroadcast].place
    const currentPerformance = currentPlace?.performances.find(performance => moment().isBetween(performance.start_datetime, performance.end_datetime)
    )

    const generalPartners = []
    const officialPartners = []
    const titlePartners = []

    partners.forEach((partner) => {
      switch (partner.type) {
        case 'general':
          generalPartners.push(partner)
          break
        case 'official':
          officialPartners.push(partner)
          break
        case 'title':
          titlePartners.push(partner)
          break
        default:
          break
      }
    })

    return (
      <Layout meta={{ title: t('PAGE_BROADCAST_TITLE') }}>
        <BroadcastContainer>
          <h1>{t('live_broadcast')}</h1>
          <div className="currentBroadcast">
            <div className="broadcastWindow">
              {broadcasts[currentBroadcast] ? (
                <iframe
                  src={broadcasts[currentBroadcast].iframe}
                  title="camera broadcast"
                  allowFullScreen
                />
              ) : (
                <div className="broadcastPlaceholder" />
              )}
            </div>
            {broadcasts[currentBroadcast].id !== 29 ? (
              <div className="broadcastInfoBar">
                <Link href={`/place/${currentPlace?.id}/${currentPlace?.slug}`}>
                  <a target="_blank" className="currentBroadcastStage">
                    {currentPlace?.name}
                  </a>
                </Link>
                <div className="currentBroadcastArtist">
                  <span className="now">
                    {t('now')}
                    :
                  </span>
                  {currentPerformance ? (
                    <Link
                      href={`/artist/${currentPerformance.artist.id}/${currentPerformance.artist.slug}`}
                    >
                      <a target="_blank">{currentPerformance.artist.name}</a>
                    </Link>
                  ) : (
                    t('no_artist')
                  )}
                </div>
              </div>
            ) : (
              <div className="broadcastInfoBar">
                <div target="_blank" className="currentBroadcastStage">
                  {currentPlace.name}
                </div>
              </div>
            )}
          </div>

          <Container className="partnersContainer">
            {officialPartners.length !== 0 && (
              <>
                <PartnersSection title={t('partners:OFFICIAL_PARTNERS')} />
                <PartnersGrid partners={officialPartners} />
              </>
            )}
            {generalPartners.length !== 0 && (
              <>
                <PartnersSection title={t('partners:GENERAL_PARTNERS')} />
                <PartnersGrid partners={generalPartners} />
              </>
            )}
            {titlePartners.length !== 0 && (
              <>
                <PartnersSection title={t('partners:TITLE_PARTNERS')} />
                <PartnersGrid partners={titlePartners} />
              </>
            )}
            <PartnersSection title="ТРАНСЛЯЦИИ" />
          </Container>

          <div className="otherBroadcastsList">
            {broadcasts.map(({ place, id, iframe }, i) => (
              <div
                className={`broadcastCard ${
                  currentBroadcast === i && 'broadcastCard--selected'
                }`}
                key={id}
              >
                <div className="stagePhoto">
                  <img
                    src={place?.photo || 'static/images/empty-place.svg'}
                    alt=""
                  />
                </div>
                <div className="cardStageName">{place?.name}</div>
                {place?.id === EXTERNAL_PLACE_BROADCAST_ID ? (
                  <a href={iframe} target="_blank">
                    <ReactSVG src="static/images/play-button.svg" className="stream-btn" />
                  </a>
                ) : (
                  <button
                    onClick={() => {
                      this.setState({ currentBroadcast: i })
                      document
                        && document
                          .querySelector('#sidebarContent')
                          .scrollTo({ top: 60, behavior: 'smooth' })
                    }}
                  >
                    {currentBroadcast === i ? (
                      <ReactSVG src="static/images/streaming-button.svg" className="stream-btn stream-btn--pulse" />
                    ) : (
                      <ReactSVG src="static/images/play-button.svg" className="stream-btn" />
                    )}
                  </button>
                )}

                {id !== 29 && (
                  <div className="cardBroadcastArtist cardText">
                    <span className="cardNow cardText">
                      {t('now')}
                      :
                    </span>
                    {place?.performances.reduce((acc, performance) => {
                      if (
                        moment().isBetween(
                          performance.start_datetime,
                          performance.end_datetime
                        )
                      ) {
                        return performance.artist.name
                      }
                      return acc
                    }, t('no_artist'))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <Footer />
        </BroadcastContainer>
      </Layout>
    )
  }
}

export default withTranslation(['common', 'partners'])(Broadcast)
